import { createRouter, createWebHistory } from 'vue-router'
import { useAppRoutes } from './routes.js'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: useAppRoutes(),
})

export default router
